/**
 * Determines whether a hostname is a custom tenant domain
 * (i.e. not the default application domain or a local development hostname).
 *
 * @param hostname  - The hostname to evaluate (e.g. `window.location.hostname`).
 *                    The value is normalised to lower-case before comparison.
 * @param appDomain - The configured default application domain
 *                    (e.g. `"app.cvstudio.com"`). When provided, this hostname
 *                    is treated as the canonical platform domain and therefore
 *                    NOT a custom domain.
 * @returns `true` when `hostname` should be treated as a custom tenant domain.
 */
export function isCustomDomain(hostname: string, appDomain?: string): boolean {
    const normalised = hostname.toLowerCase();
    const defaultHostnames = ['localhost', '127.0.0.1'];
    if (appDomain) {
        defaultHostnames.push(appDomain.toLowerCase());
    }

    // Vercel preview/production fallback domains are platform-owned hosts,
    // not tenant-branded custom domains.
    if (normalised.endsWith('.vercel.app')) {
        return false;
    }

    return !defaultHostnames.includes(normalised);
}
